import { ProjectReportStatus } from "../enums/project-report-status";
import { AllowedActionsMap, StateMachine, TransitionMap } from "./state-machine";

export type ProjectReportAction =
  | 'Submit'
  | 'Return'
  | 'Resubmit'
  | 'Approve'
  | 'Reject'
  // UI-only
  | 'Edit'
  | 'Delete';

// --- EXACT MIRROR of backend EnsureValidTransition ---
const transitions: TransitionMap<ProjectReportStatus> = {
  [ProjectReportStatus.Draft]: [
    ProjectReportStatus.Submitted
  ],

  [ProjectReportStatus.Submitted]: [
    ProjectReportStatus.Returned,
    ProjectReportStatus.Approved, 
    ProjectReportStatus.Rejected
  ],

  [ProjectReportStatus.Returned]: [
     ProjectReportStatus.Resubmitted
  ],

  [ProjectReportStatus.Resubmitted]: [
    ProjectReportStatus.Returned,
     ProjectReportStatus.Approved, 
     ProjectReportStatus.Rejected
  ]
  // Approved / Rejected are terminal
};

// --- EXACT MIRROR of backend allowed actions (+ UI-only Edit/Delete where appropriate) ---
const allowedActions: AllowedActionsMap<ProjectReportStatus, ProjectReportAction> = {
  [ProjectReportStatus.Draft]:       ['Edit', 'Delete', 'Submit'],
  [ProjectReportStatus.Submitted]:   ['Return', 'Approve', 'Reject'],
  [ProjectReportStatus.Returned]:    ['Edit', 'Resubmit'],
  [ProjectReportStatus.Resubmitted]: ['Return', 'Approve', 'Reject'],
  [ProjectReportStatus.Approved]:    [],
  [ProjectReportStatus.Rejected]:    [],
};

export const ProjectReportStateMachine = new StateMachine<ProjectReportStatus, ProjectReportAction>({
  transitions,
  allowedActions,
});